module.exports = __webpack_public_path__ + "img/Demon.84310782.jpg";